import React, { useEffect, useRef, useState } from "react";

/**
 * Šest políček na kód z e-mailu (deska 19). Pod nimi je jeden skutečný input —
 * funguje vložení ze schránky, automatické doplnění kódu z e-mailu na iOS
 * (autocomplete="one-time-code") i mazání. Po 6. číslici zavolá onHotovo.
 */
export default function KodPole({ onHotovo, disabled = false, chyba = false, ok = false, testid = "kod" }) {
  const [v, setV] = useState("");
  const [fokus, setFokus] = useState(true);
  const ref = useRef(null);
  useEffect(() => { ref.current?.focus(); }, []);
  // Po chybě se políčka vyprázdní a jde psát znovu.
  useEffect(() => { if (chyba) { setV(""); ref.current?.focus(); } }, [chyba]);

  const zmena = (e) => {
    const cisla = e.target.value.replace(/\D/g, "").slice(0, 6);
    setV(cisla);
    if (cisla.length === 6) onHotovo(cisla);
  };

  return (
    <div className="relative" onClick={() => ref.current?.focus()}>
      <input ref={ref} value={v} onChange={zmena} disabled={disabled} inputMode="numeric" autoComplete="one-time-code"
        maxLength={6} aria-label="Kód z e-mailu" data-testid={testid}
        onFocus={() => setFokus(true)} onBlur={() => setFokus(false)}
        className="absolute inset-0 w-full h-full opacity-0 text-[16px] cursor-pointer" />
      <div className="grid grid-cols-6 gap-2 md:gap-2.5 pointer-events-none" aria-hidden="true">
        {[0, 1, 2, 3, 4, 5].map((i) => {
          const aktivni = fokus && !disabled && i === Math.min(v.length, 5);
          return (
            <span key={i} className={`kod-bunka h-[58px] md:h-[60px] rounded-[14px] flex items-center justify-center text-[24px] font-800 amount transition-colors ${
              ok ? "je-ok bg-success-bg text-success shadow-[inset_0_0_0_1.5px_#9fd9c0]"
                : chyba ? "je-chyba bg-white shadow-[inset_0_0_0_1.5px_#d93a2b]"
                  : aktivni ? "je-aktivni bg-white shadow-[inset_0_0_0_2px_#14161a]"
                    : v[i] ? "bg-white shadow-[inset_0_0_0_1px_#e0deda]" : "bg-inputbg shadow-[inset_0_0_0_1px_#e0deda]"}`}>
              {v[i] || ""}
            </span>
          );
        })}
      </div>
    </div>
  );
}

/** „Nepřišel? Poslat znovu za 0:42“ → po odpočtu tlačítko. */
export function PoslatZnovu({ onPoslat, sekund = 45, testid = "kod-znovu" }) {
  const [zbyva, setZbyva] = useState(sekund);
  useEffect(() => {
    if (zbyva <= 0) return undefined;
    const t = setTimeout(() => setZbyva((x) => x - 1), 1000);
    return () => clearTimeout(t);
  }, [zbyva]);
  if (zbyva > 0) {
    return <span className="block t-meta text-muted" data-testid={testid}>Nepřišel? Poslat znovu za 0:{String(zbyva).padStart(2, "0")}</span>;
  }
  return (
    <button type="button" data-testid={testid} className="tap md:min-h-0 t-meta font-700 text-accent"
      onClick={async () => { setZbyva(sekund); await onPoslat(); }}>
      Poslat kód znovu
    </button>
  );
}
